/**
 * Isopod Kit Builder
 * Step 1: Select kit (expandable detail panel)
 * Step 2: Select isopod set (expandable species tiles)
 * Add to cart: silent Ajax, opens cart drawer
 */
(function () {
  'use strict';

  const builder = document.getElementById('isopod-kit-builder');
  if (!builder) return;

  // ── Elements ────────────────────────────────────────────
  const step1       = builder.querySelector('.ikb__step--1');
  const step2       = builder.querySelector('.ikb__step--2');
  const backBtn     = document.getElementById('ikbBack');
  const kitNameEl   = document.getElementById('ikbSelectedKitName');
  const footer      = document.getElementById('ikbFooter');
  const footerLabel = document.getElementById('ikbFooterLabel');
  const footerPrice = document.getElementById('ikbFooterPrice');
  const atcBtn      = document.getElementById('ikbAtcBtn');
  const atcText     = document.getElementById('ikbAtcText');
  const atcLoading  = document.getElementById('ikbAtcLoading');

  // ── State ───────────────────────────────────────────────────
  let activeVariant = null;

  // ── Step 1: Kit card interactions ─────────────────────────────────
  builder.addEventListener('click', function (e) {

    // Select kit (main row click or "Choose isopods" button)
    const selectTrigger = e.target.closest('[data-action="select-kit"]');
    if (selectTrigger) {
      const card = selectTrigger.closest('.ikb__kit-card') || selectTrigger;
      const kitId = card.dataset.kitId || selectTrigger.dataset.kitId;
      if (kitId) { selectKit(kitId, card); return; }
    }

    // Toggle kit expand panel
    const expandBtn = e.target.closest('[data-action="toggle-kit-expand"]');
    if (expandBtn) {
      e.stopPropagation();
      const card = expandBtn.closest('.ikb__kit-card');
      toggleKitExpand(card, expandBtn);
      return;
    }

    // Toggle set expand panel
    const setExpandBtn = e.target.closest('[data-action="toggle-set-expand"]');
    if (setExpandBtn) {
      e.stopPropagation();
      const card = setExpandBtn.closest('.ikb__set-card');
      toggleSetExpand(card, setExpandBtn);
      return;
    }

    // Select set card
    const setCard = e.target.closest('.ikb__set-card');
    if (setCard && !e.target.closest('[data-action="toggle-set-expand"]')) {
      selectSet(setCard);
      return;
    }

  });

  // keyboard support for set cards
  builder.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    const setCard = e.target.closest('.ikb__set-card');
    if (setCard) { e.preventDefault(); selectSet(setCard); }
  });

  // ── Select kit ──────────────────────────────────────────────
  function selectKit(kitId, card) {
    const kitName = card
      ? card.querySelector('.ikb__kit-name')?.textContent.trim()
      : builder.querySelector(`[data-kit-id="${kitId}"] .ikb__kit-name`)?.textContent.trim();

    // Reset set selection
    activeVariant = null;
    resetFooter();
    builder.querySelectorAll('.ikb__set-card--selected').forEach(el => {
      el.classList.remove('ikb__set-card--selected');
      el.removeAttribute('aria-pressed');
    });

    // Show correct set panel
    builder.querySelectorAll('.ikb__sets').forEach(el => el.hidden = true);
    const panel = document.getElementById('ikbSets-' + kitId);
    if (panel) panel.hidden = false;

    // Update heading
    if (kitNameEl) kitNameEl.textContent = kitName ? ' \u2014 ' + kitName : '';

    // Transition
    goToStep(2);
    builder.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  // ── Kit expand/collapse ─────────────────────────────────────────
  function toggleKitExpand(card, btn) {
    const detail = card.querySelector('.ikb__kit-detail');
    const isExp = !detail.hidden;
    detail.hidden = isExp;
    btn.setAttribute('aria-expanded', String(!isExp));
    btn.innerHTML = isExp
      ? '<svg width="10" height="10" viewBox="0 0 12 12" fill="none" aria-hidden="true"><path d="M2 4l4 4 4-4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg> More'
      : '<svg width="10" height="10" viewBox="0 0 12 12" fill="none" aria-hidden="true"><path d="M2 8l4-4 4 4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg> Less';
  }

  // ── Set expand/collapse ─────────────────────────────────────────
  function toggleSetExpand(card, btn) {
    const detail = card.querySelector('.ikb__set-detail');
    const isExp = !detail.hidden;
    detail.hidden = isExp;
    btn.setAttribute('aria-expanded', String(!isExp));
    btn.innerHTML = isExp
      ? '<svg width="10" height="10" viewBox="0 0 12 12" fill="none" aria-hidden="true"><path d="M2 4l4 4 4-4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg> More'
      : '<svg width="10" height="10" viewBox="0 0 12 12" fill="none" aria-hidden="true"><path d="M2 8l4-4 4 4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg> Less';
  }

  // ── Select set ──────────────────────────────────────────────
  function selectSet(card) {
    builder.querySelectorAll('.ikb__set-card--selected').forEach(el => {
      el.classList.remove('ikb__set-card--selected');
      el.removeAttribute('aria-pressed');
    });
    card.classList.add('ikb__set-card--selected');
    card.setAttribute('aria-pressed', 'true');

    activeVariant = card.dataset.variantId;
    const label   = card.dataset.label || 'Selected set';
    const price = card.dataset.price;

    if (footer) footer.hidden = false;
    if (footerLabel) footerLabel.textContent = label;
    if (footerPrice) footerPrice.textContent = formatMoney(price);
    if (atcBtn) { atcBtn.disabled = false; }
    if (atcText) atcText.textContent = 'Add to cart';
  }

  // ── Back button ───────────────────────────────────────────
  if (backBtn) {
    backBtn.addEventListener('click', function () {
      activeVariant = null;
      resetFooter();
      goToStep(1);
      builder.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  // ── Add to cart ───────────────────────────────────────────
  if (atcBtn) {
    atcBtn.addEventListener('click', addToCart);
  }

  async function addToCart() {
    if (!activeVariant || atcBtn.disabled) return;

    atcBtn.disabled = true;
    if (atcText) atcText.hidden = true;
    if (atcLoading) atcLoading.hidden = false;

    try {
      const res = await fetch(window.__IKB_CART_URL__, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(activeVariant, 10), quantity: 1 }] })
      });

      if (!res.ok) throw new Error('Cart error ' + res.status);

      // Trigger cart drawer — try common Shopify theme patterns
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      document.dispatchEvent(new CustomEvent('cart:open'));
      const drawerTrigger = document.querySelector(
        '[data-cart-toggle], [data-drawer-toggle="cart"], #cart-icon-bubble, .js-drawer-open-cart'
      );
      if (drawerTrigger) drawerTrigger.click();

      if (atcText) { atcText.hidden = false; atcText.textContent = '✓ Added to cart'; }
      setTimeout(() => {
        if (atcText) atcText.textContent = 'Add to cart';
        if (atcBtn) atcBtn.disabled = false;
      }, 2000);

    } catch (err) {
      console.error('[IKB] Add to cart failed:', err);
      if (atcText) { atcText.hidden = false; atcText.textContent = 'Something went wrong — try again'; }
      if (atcBtn) atcBtn.disabled = false;
    } finally {
      if (atcLoading) atcLoading.hidden = true;
    }
  }

  // ── Helpers ──────────────────────────────────────────────
  function goToStep(n) {
    builder.dataset.step = n;
    step1.classList.toggle('ikb__step--active', n === 1);
    step2.classList.toggle('ikb__step--active', n === 2);
  }

  function resetFooter() {
    if (footer) footer.hidden = true;
    if (atcBtn) { atcBtn.disabled = true; }
    if (atcText) atcText.textContent = 'Select a set above';
  }

  function formatMoney(centavos) {
    if (!centavos) return '';
    return '\u20B1' + (parseInt(centavos, 10) / 100).toLocaleString('en-PH', { minimumFractionDigits: 2 });
  }

  })();
